interface LocalizeIconProps {
  className?: string
}
export default function LocalizeIcon({ className }: LocalizeIconProps) {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.515137 3.44444V2.22222C0.515137 1.89807 0.643906 1.58719 0.873117 1.35798C1.10233 1.12877 1.41321 1 1.73736 1H2.95958M9.07069 1H10.2929C10.6171 1 10.9279 1.12877 11.1572 1.35798C11.3864 1.58719 11.5151 1.89807 11.5151 2.22222V3.44444M11.5151 9.55556V10.7778C11.5151 11.1019 11.3864 11.4128 11.1572 11.642C10.9279 11.8712 10.6171 12 10.2929 12H9.07069M2.95958 12H1.73736C1.41321 12 1.10233 11.8712 0.873117 11.642C0.643906 11.4128 0.515137 11.1019 0.515137 10.7778V9.55556M7.84847 6.5C7.84847 7.51252 7.02766 8.33333 6.01514 8.33333C5.00261 8.33333 4.1818 7.51252 4.1818 6.5C4.1818 5.48748 5.00261 4.66667 6.01514 4.66667C7.02766 4.66667 7.84847 5.48748 7.84847 6.5Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
